import { render, staticRenderFns } from "./PortalView.vue?vue&type=template&id=36817cc5&"
import script from "./PortalView.vue?vue&type=script&lang=js&"
export * from "./PortalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../ceesar.portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports